module.exports = __webpack_public_path__ + "img/l3.1c53d414.png";